import { render, staticRenderFns } from "./BrandSeoSettings.vue?vue&type=template&id=6ceb4d6a&scoped=true"
import script from "./BrandSeoSettings.vue?vue&type=script&lang=js"
export * from "./BrandSeoSettings.vue?vue&type=script&lang=js"
import style0 from "./BrandSeoSettings.vue?vue&type=style&index=0&id=6ceb4d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceb4d6a",
  null
  
)

export default component.exports